<template>
    <div v-if="src" class='preview-image'>
        <img :src="src" style="max-height:96px; border: solid black 1px" class="mb-2 mr-2 border-primary">
        <div class="text-center mt-4 preview-image__overlay preview-image__overlay--loading" v-if="loading">
            <div class="spinner-border text-light" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            src: '',
            loading: true,
            reader: null,
        }
    },
    props: {
        value:{
            type: Object,
            required: true
        }
    },

    mounted() {
        this.src = URL.createObjectURL(this.fileObject);
        this.upload();
    },

    methods: {
        readImage: function () {
            this.src = URL.createObjectURL(this.fileObject);
        },
        upload: function () {
            let data = new FormData();
            data.append('image', this.$props.value.file);
            
            window.axios.post('email/upload', data, {
                headers: {'Content-Type': 'multipart/form-data'}
            })
                .then(({data}) => this.success(data))
                .catch(error => this.failed(error))
        },
        success: function (data) {
            this.loading = false;
            this.$emit('input', {
                file: this.$props.value.file,
                id: data.id,
            });
        },
        failed: function (error) {
            error;
        },
    },

    computed: {
        fileObject: function () {
            return this.$props.value.file;
        }
    }
}
</script>

<style lang="scss">
.preview-image {
    position: relative;
    display: inline-block;
    &__overlay--loading {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
}
</style>